import { useEffect, useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import { CLINIC, IMAGES, whatsappUrl } from "@/lib/clinic";

const NAV = [
  { label: "Patologías", href: "#patologias" },
  { label: "Obras Sociales", href: "#obras-sociales" },
  { label: "Equipo", href: "#equipo" },
  { label: "Ubicación", href: "#ubicacion" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-cream/80 backdrop-blur-xl border-b border-navy-900/5 shadow-[0_2px_20px_rgba(11,27,61,0.04)]"
          : "bg-transparent"
      }`}
    >
      <div className="section-container flex items-center justify-between h-24">
        <a
          href="#top"
          data-testid="header-logo"
          className="flex items-center gap-4"
          aria-label="Salud Ocular · Inicio"
        >
          <img
            src={IMAGES.logo}
            alt="Salud Ocular · Instituto Oftalmológico en Paraná"
            className="h-20 w-20 object-contain"
          />
          <div className="hidden sm:flex flex-col leading-none">
            <span className="font-display font-semibold text-navy-900 text-[28px] tracking-tight">
              Salud Ocular
            </span>
            <span className="mt-2 text-[11px] tracking-[0.26em] uppercase text-turquoise-700 font-semibold">
              Instituto Oftalmológico
            </span>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-link-${item.href.replace("#", "")}`}
              className="text-sm font-medium text-navy-800/80 hover:text-turquoise-700 transition-colors"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={whatsappUrl()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-whatsapp-cta"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-navy-900 hover:bg-navy-800 text-cream px-5 py-2.5 text-sm font-medium transition-colors"
          >
            <MessageCircle className="w-4 h-4" strokeWidth={2.2} />
            Agendá tu turno
          </a>
          <button
            type="button"
            className="lg:hidden inline-flex items-center justify-center w-11 h-11 rounded-full bg-white border border-navy-900/10 text-navy-900"
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Abrir menú"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-cream border-t border-navy-900/5"
        >
          <div className="section-container py-6 flex flex-col gap-4">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${item.href.replace("#", "")}`}
                className="text-base text-navy-800 font-medium py-2"
              >
                {item.label}
              </a>
            ))}
            <a
              href={whatsappUrl()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-whatsapp-cta"
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-turquoise-500 text-navy-900 px-5 py-3 text-sm font-semibold"
            >
              <MessageCircle className="w-4 h-4" /> Agendá tu turno por WhatsApp
            </a>
            <p className="text-xs text-navy-700/60 pt-2">
              {CLINIC.phoneDisplay} · {CLINIC.schedule}
            </p>
          </div>
        </div>
      )}
    </header>
  );
}
